angular.module('CarsSaraBo').config(['$routeProvider', '$locationProvider', function ($routeProvider, $locationProvider) {

    $locationProvider.html5Mode({
        enabled: true,
        requireBase: true
    });
}]);

angular.module('CarsSaraBo').run(['$rootScope', '$page', 'SidebarService', function ($rootScope, $page, sidebarService) {
    $rootScope.$on('$routeChangeSuccess', function (event, current, previous) {
        // $page.setTitle(current.$$route.title)
        sidebarService.sidebar = (!current || !current.$$route)? "" : current.$$route.sidebar;
    });
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/routes/routes_config.js
// module id = 820
// module chunks = 3